import * as PIXI from 'pixi.js';
import { TypedSerializableMixin } from '../../serializableMixin';
import { TypedUpdateFlowMixin } from '../../updateFlowMixin';
import type { IReactionDisposer } from '../../reactivity';
import type { DestroyOptions } from '../../../types';

/**
 * Base class for the dynamic styling graphics. A graphic has to be a `PIXI.Graphics`, so it cannot extend
 * `ReactiveBase`; this gives it the same reaction lifetime: reactions registered through
 * [addReaction]{@link ReactiveGraphic#addReaction} are disposed when the graphic is destroyed.
 */
export abstract class ReactiveGraphic extends TypedUpdateFlowMixin(
    TypedSerializableMixin(PIXI.Graphics),
) {
    #disposers: IReactionDisposer[] = [];

    /**
     * Ties the lifetime of a mobx reaction to this graphic. Register from the constructor, after assigning every
     * property the reaction reads.
     */
    protected addReaction(disposer: IReactionDisposer): void {
        this.#disposers.push(disposer);
    }

    override destroy(options?: DestroyOptions) {
        this.#disposers.forEach((dispose) => dispose());
        this.#disposers.length = 0;
        super.destroy(options);
    }
}
